module.exports = __webpack_public_path__ + "img/embu.91bcfee8.png";